import styled from 'styled-components';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_350 } from '@oneaudi/unified-web-common';
import { DISPLAY_SIZE, ONE_HEADER_HEIGHT } from '../global.style.constants';

const device = {
  desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
  largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
  smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
  mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
  tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
  smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};

interface Props {
  desktopImg: string;
  mobileImg: string;
  isDesktop?: boolean;
  oneHeader?: boolean;
  isListView?: boolean;
  isLegacy?: boolean | string;
}

export const TwoClickConsentWrapper = styled.div<Props>`
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.7);
  background-image: ${(props) => !props.oneHeader && `url(${props.mobileImg})`};
  background-position: inherit;
  background-size: cover;
  background: ${(props) => props.oneHeader && 'transparent'};
  height: ${(props) => {
    if (props.isDesktop && !props.oneHeader) {
      return `calc(100vh - ${ONE_HEADER_HEIGHT})`;
    }
    return 'auto';
  }};
  max-width: ${DISPLAY_SIZE.LARGE_DESKTOP};
  min-height: ${(props) => {
    if (props.isDesktop) {
      return '0';
    }
    return props.isListView ? 'auto' : '884px';
  }};
  max-height: ${(props) => props.isDesktop && !props.oneHeader && '1080px'};
  ${(props) => !props.oneHeader && `overflow: hidden`};
  position: relative;
  width: 100%;

  @media ${device.tablet} {
    background-image: ${(props) => !props.oneHeader && `url(${props.desktopImg})`};
  }

  ${({ isLegacy, oneHeader }) =>
    !isLegacy &&
    !oneHeader &&
    `
    dialog {
      display: block;
      max-height: 100%;
      overflow-y: auto;
    }

    display: flex;
    align-items: center;
  `}

  ${({ isLegacy, oneHeader }) =>
    !isLegacy &&
    oneHeader &&
    `
    dialog {
      display: block;
      position:absolute;
      top: 0;
    }

    display: flex;
    align-items: center;
  `}
`;

export const MapToggleContainer = styled.div<{ isLegacy: any }>`
  align-items: baseline;
  background-color: ${(props) => (props.isLegacy ? '#f2f2f2' : 'unset')};
  bottom: 40px;
  column-gap: 19px;
  display: grid;
  padding: ${(props: { isLegacy: any }) =>
    props.isLegacy
      ? `23px ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200}`
      : `0 ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200}`};

  p {
    margin: 0;
    max-width: 343px;
  }

  .revoke-consent {
    color: ${(props: { isLegacy: any }) =>
      props.isLegacy ? '#000' : 'var(--Sys-Color-Text-Caption-Default, rgba(252, 252, 253, 0.7))'};
    font-size: var(--Sys-FontSizes-Relative-62_5, 10px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Sys-LineHeights-Relative-LH100, 16px); /* 160% */
    letter-spacing: var(--Sys-LetterSpacing-None, 0);
    margin: ${SYS_SPACE_FIXED_200} 0 0;
  }

  .revoke-consent-label {
    align-self: center;
    font-size: 12px;
    font-style: normal;
    letter-spacing: -0.015em;
    line-height: 167%;
    padding: 0;
  }

  @media ${device.smallTablet} {
    bottom: unset;
    padding: 0 ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_350};
    width: auto;
    z-index: 40;

    .revoke-consent {
      align-self: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: -0.015em;
      line-height: 167%;
      padding: 0;
    }
    .revoke-consent-label {
      align-self: center;
      font-size: 12px;
      font-style: normal;
      letter-spacing: -0.015em;
      line-height: 167%;
      padding: 0;
    }
  }
`;
